<template>
  <AppModal heading="Verify Account" @close="closeModal(null)">
    <div slot="content">
      <ValidationObserver ref="formObserver" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <label>Deposited Amount 1</label>
            <input
              class="form-input"
              type="number"
              name="Deposited Amount 1"
              placeholder="Deposited Amount 1"
              v-model="formData.amount1"
            >
            <div class="input-error">{{ errors[0] }}</div>
          </ValidationProvider>
          <ValidationProvider v-slot="{ errors }" rules="required">
            <label>Deposited Amount 2</label>
            <input
              class="form-input"
              type="number"
              name="Deposited Amount 2"
              placeholder="Deposited Amount 2"
              v-model="formData.amount2"
            >
            <div class="input-error">{{ errors[0] }}</div>
          </ValidationProvider>
          <button class="new-app-btn bg-blue">Verify Account</button>
        </form>
      </ValidationObserver>
    </div>
  </AppModal>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'VerifyAchAccountModal',
  props: {
    id: {
      required: true
    }
  },
  data() {
    return {
      formData: {
        amount1: '',
        amount2: '',
        bank_id: this.id
      }
    }
  },
  methods: {
    ...mapActions ([
      'verifyBuyerAchAccount'
    ]),
    closeModal() {
      this.$emit('close')
    },
    async onSubmit() {
      const response = await this.verifyBuyerAchAccount(this.formData)
      if (response.result) this.closeModal()

      this.$notify({
        group: 'buyHive',
        type: response.result ? 'success' : 'error',
        text: response.message,
        duration: 7000
      })
    }
  }
}
</script>
